import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsAuthenticationBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Authentication</div>
          <div className="text">
            API requests must be authenticated by including your secret API key. You can find your
            secret API key in{' '}
            <div className="emphasize">Your Canny Subdomain &gt; Settings &gt; API</div>. This key
            is secret, so be careful not to share it publicly and don't store it in the client side
            of your&nbsp;app.
          </div>
          <div className="text">
            You can include your secret API key in a request by adding it as a POST parameter with
            key&nbsp;apiKey.
          </div>
        </div>
        <div>
          <div className="text">Example request:</div>
          <Highlight lang="shell">
            {`$ curl https://canny.io/api/v1/boards/list \\
    -d apiKey=YOUR_API_KEY`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
